import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Section from '../common/Section';
import { getFeaturedProjects } from '../../lib/markdown';
import type { Project } from '../../types/project';

export default function FeaturedProjects() {
  const [projects, setProjects] = useState<Project[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getFeaturedProjects().then(data => {
      setProjects(data.slice(0, 3));
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <Section>
        <div className="container-custom">
          <h2 className="text-5xl md:text-6xl font-heading font-bold mb-12 text-center">
            精选项目
          </h2>
          <div className="text-center text-xl">加载中...</div>
        </div>
      </Section>
    );
  }

  if (projects.length === 0) {
    return (
      <Section>
        <div className="container-custom">
          <h2 className="text-5xl md:text-6xl font-heading font-bold mb-12 text-center">
            精选项目
          </h2>
          <div className="text-center text-xl text-gray-600">
            暂无项目展示
          </div>
        </div>
      </Section>
    );
  }

  return (
    <Section className="bg-gray-50">
      <div className="container-custom">
        <h2 className="text-5xl md:text-6xl font-heading font-bold mb-12 text-center">
          精选项目
        </h2>
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {projects.map((project) => (
            <Link
              key={project.slug}
              to={`/projects/${project.slug}`}
              className="card-neubrutal bg-white p-6 rounded-lg"
            >
              {project.coverImage && (
                <div className="aspect-video mb-4 bg-gradient-to-br from-primary/20 to-cta/20 border-2 border-black rounded-lg flex items-center justify-center overflow-hidden">
                  <span className="text-6xl">🚀</span>
                </div>
              )}
              <h3 className="text-2xl font-heading font-bold mb-2">
                {project.title}
              </h3>
              <p className="text-gray-600 mb-4 line-clamp-2">
                {project.description}
              </p>
              <div className="flex flex-wrap gap-2">
                {project.techStack.slice(0, 3).map((tech) => (
                  <span
                    key={tech}
                    className="text-xs px-2 py-1 border-2 border-black bg-secondary rounded-full"
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </Link>
          ))}
        </div>
        <div className="text-center">
          <Link to="/projects" className="btn-neubrutal bg-cta text-white px-8 py-3">
            查看所有项目
          </Link>
        </div>
      </div>
    </Section>
  );
}
